<template>
  <div data-app>
    <div class="page-header">      
      <parallax
        class="page-header-image"
        style="background-image: url('img/transplus_landing.jpg')"
      />
      

      <div
        v-show="!evista.show"
        class="content-center"
      >
        <!-- Services -->
        <div style="min-height:550px">
          <div class="container">
            <div
              class="row elgrey"
              style="padding-top:25px"
            >
              <div
                class="col-md-6 pophover elmaster"
                @click="toggleEvista()"
              >
                <card style="min-height:520px">
                  <img
                    slot="image"
                    class="card-img-top"
                    :src="imgWare"
                    alt="Card image cap"
                  >              
                  <h4 class="card-title">
                    Warehouse Documents
                  </h4>
                  <p
                    class="card-text"
                    style="font-size:14px"
                  >
                    Online customer portal allows our customers to view signed & attached warehouse documents
                  </p>              
                </card>
              </div>

              <div
                class="col-md-6 pophover elmaster"
                @click="open('http://evista.transplus.ca', '_blank');"
              >
                <card style="min-height:520px">
                  <img
                    slot="image"
                    class="card-img-top"
                    :src="imgEvista"
                    alt="Card image cap"
                  >              
                  <h4 class="card-title">
                    Warehouse Web Portal : Evista
                  </h4>
                  <p
                    class="card-text"
                    style="font-size:14px"
                  >
                    Evista online customer portal allows our customers to view orders, receipts, inventory balances and history
                  </p>              
                </card>
              </div>
            </div>
          </div>
        </div>                  
      </div>

      <div
        v-show="evista.show"
        class="content-center"
      >
        <!-- Services -->        
        <div class="container">
          <!--
                <label >User </label>
                <input aria-describedby="addon-right addon-left"  stlye="background-color:white" v-model="evista.user">
              
                <label >Password </label>
                <input aria-describedby="addon-right addon-left" class="custom_form" v-model="evista.pass">
                
                <button type="button" v-on:click="loginload">Login</button>
                -->
                
               
          <v-form v-if="orders.length==0">
            <v-container>
              <v-card>
                <v-card-title>
                  Login
                  <v-spacer />
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="evista.user"
                        label="User"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="evista.pass"
                        label="Password"
                        type="password"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-btn
                        style="margin-top:15px;"
                        @click="loginload"
                      >
                        Login
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>                      
              </v-card>
            </v-container>
          </v-form>




        <!-- TABBED VIEW ADDED -->
        <v-card v-if="(orders.length > 0 || receipts.length > 0) && !showDetailDialog && !showReceiptDetailDialog">
          <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
            <v-tab>Warehouse Orders</v-tab>
            <v-tab>Warehouse Receipts</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-card-title>
                  Warehouse Orders <small style="margin-left:10px;">(last 365days)</small>
                  <v-spacer />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                </v-card-title>
                <v-data-table
                  :headers="headers"                
                  :items="orders"
                  :search="search"
                  :items-per-page="10"
                  class="elevation-1"
                  @click:row="rowClick"                    
                />
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-card-title>
                  Warehouse Receipts <small style="margin-left:10px;">(last 365days)</small>
                  <v-spacer />
                  <v-text-field
                    v-model="receiptSearch"
                    append-icon="mdi-magnify"
                    label="Search Receipts"
                    single-line
                    hide-details
                  />
                </v-card-title>
                <v-data-table
                  :headers="receiptHeaders"                
                  :items="receipts"
                  :search="receiptSearch"
                  :items-per-page="10"
                  class="elevation-1"
                  @click:row="receiptRowClick"                    
                />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        </div>      
        <!--
        <div v-if="orders">
          <li v-for="order in orders">
            <span>
              {{order.CUST_CODE}}
              {{order.ORD_NUM}}
              {{order.CUSTOMER_REF}}
              {{order.PONUMBER}}
            </span>
          </li>
        </div>
        -->
      </div>
    </div>


        <!-- HERO MODAL FOR ORDER DETAILS -->
        <v-dialog 
          v-model="showDetailDialog" 
          max-width="95vw"
          width="95vw"
          height="85vh"
          scrollable
          transition="dialog-bottom-transition"
        >
          <v-card class="grey lighten-5">
            <!-- HERO HEADER -->
            <v-toolbar dark color="primary">              
              <v-icon  @click="showDetailDialog = false">mdi-close</v-icon> 
              <h2 style="margin-top:25px;">Order Number: {{ selected ? selected.ORD_NUM : '' }}</h2>
            </v-toolbar>

            <!-- Floating Content Container -->
            <v-container class="mt-n16" style="max-width: 95vw;"> 
               <v-row>
                  <!-- LEFT COLUMN: Key Info & Docs -->
                  <v-col cols="12" md="3">
                     <!-- KEY INFO CARD -->
                     <v-card class="rounded-lg elevation-3 mb-4">
                        <v-card-text class="pa-4">
                           <div class="subtitle-2 grey--text">PO Number</div>
                           <div class="text-h6 mb-3">{{ selected ? selected.PONUMBER : '-' }}</div>
                           
                           <v-divider class="mb-3"></v-divider>

                           <div class="subtitle-2 grey--text">Customer Ref</div>
                           <div class="body-1 mb-3">{{ selected ? selected.CUSTOMER_REF : '-' }}</div>

                           <div class="subtitle-2 grey--text">Confirmation Date</div>
                           <div class="body-1 mb-3">{{ selected ? selected.ORD_CONF_DATE : '-' }}</div>

                           <div class="subtitle-2 grey--text">Consignee</div>
                           <div class="body-1">{{ selected ? selected.CON_NAME : '-' }}</div>
                        </v-card-text>
                     </v-card>

                      <!-- SHIPPING CARD -->
                     <v-card class="rounded-lg elevation-3 mb-4" v-if="selectedOrderDetails && selectedOrderDetails.header">
                        <v-card-title class="subtitle-1 font-weight-bold">
                           <v-icon left small color="primary">mdi-truck-delivery</v-icon> Shipping
                        </v-card-title>
                        <v-divider></v-divider>
                         <v-list dense>
                            <v-list-item>
                               <v-list-item-content>Carrier:</v-list-item-content>
                               <v-list-item-content class="align-end font-weight-medium">{{ selected ? selected.CARR_CODE : '-' }}</v-list-item-content>
                            </v-list-item>
                             <v-list-item>
                               <v-list-item-content>Ship Date:</v-list-item-content>
                               <v-list-item-content class="align-end font-weight-medium">{{ selectedOrderDetails.header.ORD_TO_SHIP_DATE || '-' }}</v-list-item-content>
                            </v-list-item>
                             <v-list-item>
                               <v-list-item-content>Arrive Date:</v-list-item-content>
                               <v-list-item-content class="align-end font-weight-medium">{{ selectedOrderDetails.header.ORD_TO_ARR_DATE || '-' }}</v-list-item-content>
                            </v-list-item>
                         </v-list>
                     </v-card>
                  </v-col>

                  <!-- MIDDLE/RIGHT: Lines & Docs -->
                  <v-col cols="12" md="9">
                     <!-- LINE ITEMS -->
                     <v-card class="rounded-lg elevation-3 mb-4" min-height="400" v-if="false">
                        <v-card-title>
                           <v-icon left color="primary">mdi-format-list-bulleted</v-icon> Line Items
                           <v-spacer></v-spacer>
                           <v-text-field
                              v-model="lineSearch"
                              append-icon="mdi-magnify"
                              label="Filter Items"
                              single-line
                              hide-details
                              dense
                              outlined
                              style="max-width: 300px;"
                           ></v-text-field>
                        </v-card-title>
                        <v-data-table
                           v-if="selectedOrderDetails && selectedOrderDetails.lines"
                           :headers="lineHeaders"
                           :items="selectedOrderDetails.lines"
                           :search="lineSearch"
                           :items-per-page="10"
                           class="elevation-0"
                        >
                           <template v-slot:item.ORD_ORD_QTY="{ item }">
                              <v-chip small color="primary lighten-4" text-color="primary" class="font-weight-bold">
                                 {{ item.ORD_ORD_QTY }}
                              </v-chip>
                           </template>
                        </v-data-table>
                         <div v-else class="pa-8 text-center grey--text">
                             <v-progress-circular indeterminate color="primary" size="64" v-if="loadingDetails"></v-progress-circular>
                             <span v-else>No items to display</span>
                         </div>
                     </v-card>

                     <!-- DOCUMENTS SECTION -->
                     <v-card class="rounded-lg elevation-3" style="max-height: 60vh; overflow-y: auto;">
                         <v-card-title>
                           <v-icon left color="primary">mdi-file-document-multiple</v-icon> Documents
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                           <div v-if="files.length===0" class="text-center grey--text pa-4">
                              No documents attached.
                           </div>
                           <v-row v-else>
                              <v-col
                                 v-for="file in files"
                                 :key="file.mediaLink"
                                 cols="6"
                                 sm="4"
                                 md="3"
                              >
                                 <v-card
                                    hover
                                    class="rounded-lg overflow-hidden elevation-1"
                                    @click="open(file.mediaLink, '_blank')"
                                 >
                                    <div
                                       v-if="isImage(file.file)"
                                       style="height: 120px; background-size: cover; background-position: center;"
                                       :style="{ backgroundImage: 'url(' + file.mediaLink + ')' }"
                                    ></div>
                                    <div
                                       v-else-if="isPdf(file.file)"
                                       style="height:120px; overflow:hidden; background-color: #f5f5f5;"
                                       class="d-flex justify-center align-center"
                                    >
                                       <pdf
                                          :src="file.mediaLink"
                                          :page="1" 
                                          style="width: 100%;"
                                       ></pdf> 
                                    </div>
                                    <div
                                       v-else
                                       style="height: 120px;"
                                       class="d-flex align-center justify-center grey lighten-3"
                                    >
                                       <v-icon size="48" color="grey">mdi-file-document-outline</v-icon>
                                    </div>
                                    <v-divider></v-divider>
                                    <div class="pa-2 text-caption text-truncate text-center font-weight-medium">
                                       {{ file.file }}
                                    </div>
                                 </v-card>
                              </v-col>
                           </v-row>
                        </v-card-text>
                     </v-card>
                  </v-col>
               </v-row>
            </v-container>
          </v-card>
        </v-dialog>

        <!-- HERO MODAL FOR RECEIPT DETAILS -->
        <v-dialog 
          v-model="showReceiptDetailDialog" 
          max-width="95vw"
          width="95vw"
          height="85vh"
          scrollable
          transition="dialog-bottom-transition"
        >
          <v-card class="grey lighten-5">
            <!-- HERO HEADER -->
            <v-toolbar dark color="primary">              
              <v-icon  @click="showReceiptDetailDialog = false">mdi-close</v-icon> 
              <h2 style="margin-top:25px;">Receipt Number: {{ selected ? selected.RCPT_NUM : '' }}</h2>
            </v-toolbar>

            <!-- Floating Content Container -->
            <v-container class="mt-n16" style="max-width: 95vw;"> 
               <v-row>
                  <!-- LEFT COLUMN: Key Info & Docs -->
                  <v-col cols="12" md="3">
                     <!-- KEY INFO CARD -->
                     <v-card class="rounded-lg elevation-3 mb-4">
                        <v-card-text class="pa-4">
                           <div class="subtitle-2 grey--text">Customer</div>
                           <div class="text-h6 mb-3">{{ selected ? selected.CUSTOMER : '-' }}</div>
                           
                           <v-divider class="mb-3"></v-divider>

                           <div class="subtitle-2 grey--text">Status</div>
                           <div class="body-1 mb-3">{{ selected ? selected.RCPT_STATUS : '-' }}</div>

                           <div class="subtitle-2 grey--text">Receipt Date</div>
                           <div class="body-1 mb-3">{{ selected ? selected.RCPT_DATE : '-' }}</div>

                           <div class="subtitle-2 grey--text">Expected Date</div>
                           <div class="body-1">{{ selected ? selected.RCPT_EXPECTED_DATE : '-' }}</div>
                        </v-card-text>
                     </v-card>

                      <!-- TRANSPORT CARD -->
                     <v-card class="rounded-lg elevation-3 mb-4" v-if="selectedReceiptDetails && selectedReceiptDetails.header">
                        <v-card-title class="subtitle-1 font-weight-bold">
                           <v-icon left small color="primary">mdi-truck-delivery</v-icon> Transport
                        </v-card-title>
                        <v-divider></v-divider>
                         <v-list dense>
                            <v-list-item>
                               <v-list-item-content>Carrier:</v-list-item-content>
                               <v-list-item-content class="align-end font-weight-medium">{{ selectedReceiptDetails.header.CARRIER || '-' }}</v-list-item-content>
                            </v-list-item>
                             <v-list-item>
                               <v-list-item-content>Pro Bill Num:</v-list-item-content>
                               <v-list-item-content class="align-end font-weight-medium">{{ selectedReceiptDetails.header.RCPT_PRO_BILL_NUM || '-' }}</v-list-item-content>
                            </v-list-item>
                             <v-list-item>
                               <v-list-item-content>Ref Num:</v-list-item-content>
                               <v-list-item-content class="align-end font-weight-medium">{{ selectedReceiptDetails.header.RCPT_REF_NUM || '-' }}</v-list-item-content>
                            </v-list-item>
                         </v-list>
                     </v-card>
                  </v-col>

                  <!-- MIDDLE/RIGHT: Lines & Docs -->
                  <v-col cols="12" md="9">
                     <!-- DOCUMENTS SECTION -->
                     <v-card class="rounded-lg elevation-3" style="max-height: 60vh; overflow-y: auto;">
                         <v-card-title>
                           <v-icon left color="primary">mdi-file-document-multiple</v-icon> Documents
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                           <div v-if="files.length===0" class="text-center grey--text pa-4">
                              No documents attached.
                           </div>
                           <v-row v-else>
                              <v-col
                                 v-for="file in files"
                                 :key="file.mediaLink"
                                 cols="6"
                                 sm="4"
                                 md="3"
                              >
                                 <v-card
                                    hover
                                    class="rounded-lg overflow-hidden elevation-1"
                                    @click="open(file.mediaLink, '_blank')"
                                 >
                                    <div
                                       v-if="isImage(file.file)"
                                       style="height: 120px; background-size: cover; background-position: center;"
                                       :style="{ backgroundImage: 'url(' + file.mediaLink + ')' }"
                                    ></div>
                                    <div
                                       v-else-if="isPdf(file.file)"
                                       style="height:120px; overflow:hidden; background-color: #f5f5f5;"
                                       class="d-flex justify-center align-center"
                                    >
                                       <pdf
                                          :src="file.mediaLink"
                                          :page="1" 
                                          style="width: 100%;"
                                       ></pdf> 
                                    </div>
                                    <div
                                       v-else
                                       style="height: 120px;"
                                       class="d-flex align-center justify-center grey lighten-3"
                                    >
                                       <v-icon size="48" color="grey">mdi-file-document-outline</v-icon>
                                    </div>
                                    <v-divider></v-divider>
                                    <div class="pa-2 text-caption text-truncate text-center font-weight-medium">
                                       {{ file.file }}
                                    </div>
                                 </v-card>
                              </v-col>
                           </v-row>
                        </v-card-text>
                     </v-card>
                  </v-col>
               </v-row>
            </v-container>
          </v-card>
        </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Card } from '@/components';  
  import pdf from 'vue-pdf'

  export default {
    components: { Card, pdf },   
    data() {
      return {        
        imgWare: "img/wms_docs.jpg",
        imgEvista: "img/transplus_transport.jpg",
        evista: {
          show: false,
          user: '',
          pass: ''
        },
        tab: null,
        orders: [],
        receipts: [],
        search: null,
        receiptSearch: null,
        selected: null,
        headers: [
          { text: 'ORD_NUM', value: 'ORD_NUM' },
          // { text: 'Docs', value: 'DOC_COUNT', align: 'center' },
          { text: 'CONSIGNEE', value: 'CON_NAME' },
          { text: 'CARRIER', value: 'CARR_CODE' },
          { text: 'CUSTOMER_REF', value: 'CUSTOMER_REF' },
          { text: 'PONUMBER', value: 'PONUMBER' },
          { text: 'CONFIRM_DATE', value: 'ORD_CONF_DATE' },          
        ],
        receiptHeaders: [
          { text: 'RCPT_NUM', value: 'RCPT_NUM' },
          { text: 'STATUS', value: 'RCPT_STATUS' },
          { text: 'CARRIER', value: 'CARR_CODE' },
          { text: 'PRO BILL NUM', value: 'RCPT_PRO_BILL_NUM' },
          { text: 'REF NUM', value: 'RCPT_REF_NUM' },
          { text: 'DATE', value: 'RCPT_DATE' },
        ],
        files: [],
        selectedOrderDetails: null,
        selectedReceiptDetails: null,
        loadingDetails: false,
        showDetailDialog: false, // New State
        showReceiptDetailDialog: false,
        lineSearch: '', // For filtering lines
        lineHeaders: [
            { text: 'Line #', value: 'ORD_LINE_NUM' },
            { text: 'SKU', value: 'SKU_CODE' },
            { text: 'Item', value: 'ORD_LEV1' }, 
            { text: 'Order Qty', value: 'ORD_ORD_QTY' },
            { text: 'Ship Qty', value: 'ORD_SHIP_QTY' },
            { text: 'Weight', value: 'ORD_TOT_WGT' },
            { text: 'Unit', value: 'WGT_MEAS_CODE' },
        ]

      }
    },
    methods: {
      open(url,target){
        window.open(url, target);
      },
      toggleEvista(){
        this.evista.show = !this.evista.show
      },
      loginload(){
        axios.post('https://api.transplus.com/whsedocs/loginload', {evista: this.evista} )
        .then((response) => {          
          this.orders = response.data.rows
          console.log( this.orders)
        })
        .catch(e => {
          console.log(e)
        })        

        axios.post('https://api.transplus.com/whsedocs/loginloadReceipts', {evista: this.evista} )
        .then((response) => {          
          this.receipts = response.data.rows || []
          console.log( this.receipts)
        })
        .catch(e => {
          console.log(e)
        })      
      },
      rowClick(item,row){        
        console.log("Row Clicked:", item);
        this.selected = item
        this.selectedOrderDetails = null; // Reset
        this.loadingDetails = true;
        this.showDetailDialog = true; // Open Modal directly

        // Fetch Documents - with 'orders/' prefix
        axios.post('https://api.transplus.com/whsedocs/getDocs', {prefix: 'orders/' + item.COMP_CODE + item.ORD_NUM} )
        .then((response) => {                              
          this.files = response.data
        })
        .catch(e => {
          console.log(e)
        })

        // Fetch Detailed Order Info
        axios.post('https://api.transplus.com/whsedocs/getOrderDetails', {
            ord_num: item.ORD_NUM,
            comp_code: item.COMP_CODE
        })
        .then((response) => {
            this.loadingDetails = false;
            // Handle error response from backend
            if (response.data.error) {
                console.error("Order details error:", response.data.error);
            } else {
                this.selectedOrderDetails = response.data;
            }
        })
        .catch(e => {
            console.error(e);
            this.loadingDetails = false;
        })
      },
      receiptRowClick(item,row){        
        console.log("Receipt Row Clicked:", item);
        this.selected = item
        this.selectedReceiptDetails = null; // Reset
        this.loadingDetails = true;
        this.showReceiptDetailDialog = true; // Open Modal directly

        // Fetch Documents - with 'receipts/' prefix
        axios.post('https://api.transplus.com/whsedocs/getDocs', {prefix: 'receipts/' + item.COMP_CODE + item.RCPT_NUM} )
        .then((response) => {                              
          this.files = response.data
        })
        .catch(e => {
          console.log(e)
        })

        // Fetch Detailed Receipt Info
        axios.post('https://api.transplus.com/whsedocs/getReceiptDetails', {
            rcpt_num: item.RCPT_NUM,
            comp_code: item.COMP_CODE
        })
        .then((response) => {
            this.loadingDetails = false;
            if (response.data.error) {
                console.error("Receipt details error:", response.data.error);
            } else {
                this.selectedReceiptDetails = response.data;
            }
        })
        .catch(e => {
            console.error(e);
            this.loadingDetails = false;
        })
      },
      download(url){
        window.open(url, "_blank")
      },
      isImage(filename) {
        if (!filename) return false;
        const ext = filename.split('.').pop().toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
      },
      isPdf(filename) {
        if (!filename) return false;
        const ext = filename.split('.').pop().toLowerCase();
        return ['pdf'].includes(ext);      
      }
    }
}
</script>

<style scoped>
label, button {
  margin:5px;
  padding:5px;
}
</style>
